import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"

import { PAY_FILE_STATUS_FILTER_ORDER, PAY_FILE_STATUS_TO_LABEL } from "../../constants"

import type { PayFileStatus } from "@/graphql/codegen/graphql"

interface PayFileStatusFilterProps {
  statuses: PayFileStatus[]
  onChange: (statuses: PayFileStatus[]) => void
}

export const PayFileStatusFilter: FC<PayFileStatusFilterProps> = ({ statuses, onChange }) => {
  const handleStatusToggle = (status: PayFileStatus) => (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange([...statuses, status])
    } else {
      onChange(statuses.filter((selected) => selected !== status))
    }
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {PAY_FILE_STATUS_FILTER_ORDER.map((status) => (
        <FormControlLabel
          key={status}
          control={
            <Checkbox
              checked={statuses.includes(status)}
              onChange={handleStatusToggle(status)}
              data-testid={`pay-file.filter-drawer.status-checkbox-${status}`}
            />
          }
          label={PAY_FILE_STATUS_TO_LABEL[status]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
